import { RSAA, getJSON } from "redux-api-middleware";

import { PASSCODE_SERVER, BILLING_SERVER } from "../../constants/constants";

export const BILLING_SET_ERROR_MESSAGE = "BILLING_SET_ERROR_MESSAGE";

export const EVENT_BILLING_FAILURE = "EVENT_BILLING_FAILURE";
export const EVENT_BILLING_REQUEST = "EVENT_BILLING_REQUEST";
export const EVENT_BILLING_SUCCESS = "EVENT_BILLING_SUCCESS";

export const BILLING_GET_LEDGER_ENTRY_REQUEST = "BILLING_GET_LEDGER_ENTRY_REQUEST";
export const BILLING_GET_LEDGER_ENTRY_SUCCESS = "BILLING_GET_LEDGER_ENTRY_SUCCESS";
export const BILLING_GET_LEDGER_ENTRY_FAILURE = "BILLING_GET_LEDGER_ENTRY_FAILURE";

export const BILLING_GET_LEDGER_ENTRIES_REQUEST = "BILLING_GET_LEDGER_ENTRIES_REQUEST";
export const BILLING_GET_LEDGER_ENTRIES_SUCCESS = "BILLING_GET_LEDGER_ENTRIES_SUCCESS";
export const BILLING_GET_LEDGER_ENTRIES_FAILURE = "BILLING_GET_LEDGER_ENTRIES_FAILURE";

export const BILLING_PATCH_LEDGER_ENTRIES_REQUEST = "BILLING_PATCH_LEDGER_ENTRIES_REQUEST";
export const BILLING_PATCH_LEDGER_ENTRIES_SUCCESS = "BILLING_PATCH_LEDGER_ENTRIES_SUCCESS";
export const BILLING_PATCH_LEDGER_ENTRIES_FAILURE = "BILLING_PATCH_LEDGER_ENTRIES_FAILURE";

export const BILLING_DELETE_LEDGER_ENTRIES_REQUEST = "BILLING_DELETE_LEDGER_ENTRIES_REQUEST";
export const BILLING_DELETE_LEDGER_ENTRIES_SUCCESS = "BILLING_DELETE_LEDGER_ENTRIES_SUCCESS";
export const BILLING_DELETE_LEDGER_ENTRIES_FAILURE = "BILLING_DELETE_LEDGER_ENTRIES_FAILURE";

export const BILLING_GET_DOCUMENT_NUMBERS_REQUEST = "BILLING_GET_DOCUMENT_NUMBERS_REQUEST";
export const BILLING_GET_DOCUMENT_NUMBERS_SUCCESS = "BILLING_GET_DOCUMENT_NUMBERS_SUCCESS";
export const BILLING_GET_DOCUMENT_NUMBERS_FAILURE = "BILLING_GET_DOCUMENT_NUMBERS_FAILURE";

export const BILLING_SEND_DOCUMENT_NUMBER_REQUEST = "BILLING_SEND_DOCUMENT_NUMBER_REQUEST";
export const BILLING_SEND_DOCUMENT_NUMBER_SUCCESS = "BILLING_SEND_DOCUMENT_NUMBER_SUCCESS";
export const BILLING_SEND_DOCUMENT_NUMBER_FAILURE = "BILLING_SEND_DOCUMENT_NUMBER_FAILURE";

export const BILLING_CHECK_ERRORS_REQUEST = "BILLING_CHECK_ERRORS_REQUEST";
export const BILLING_CHECK_ERRORS_SUCCESS = "BILLING_CHECK_ERRORS_SUCCESS";
export const BILLING_CHECK_ERRORS_FAILURE = "BILLING_CHECK_ERRORS_FAILURE";

export const BILLING_RESET_CONTRACT_REQUEST = "BILLING_RESET_CONTRACT_REQUEST";
export const BILLING_RESET_CONTRACT_SUCCESS = "BILLING_RESET_CONTRACT_SUCCESS";
export const BILLING_RESET_CONTRACT_FAILURE = "BILLING_RESET_CONTRACT_FAILURE";

export const BILLING_MOVE_EVN_REQUEST = "BILLING_MOVE_EVN_REQUEST";
export const BILLING_MOVE_EVN_SUCCESS = "BILLING_MOVE_EVN_SUCCESS";
export const BILLING_MOVE_EVN_FAILURE = "BILLING_MOVE_EVN_FAILURE";

export const BILLING_DOCUMENT_SET_FILTER = "BILLING_DOCUMENT_SET_FILTER";
export const BILLING_DOCUMENT_SET_NAV_COMPANY = "BILLING_DOCUMENT_SET_NAV_COMPANY";
export const BILLING_DOCUMENT_CLEAR_FILTER = "BILLING_DOCUMENT_CLEAR_FILTER";

export const BILLING_SET_FILTER = "BILLING_SET_FILTER";
export const BILLING_CLEAR_FILTER = "BILLING_CLEAR_FILTER";

export const EVENT_BILLING_RESET_BILLERROR = "EVENT_BILLING_RESET_BILLERROR";
export const BILLING_SET_RESERVECONTRACTDATE = "BILLING_SET_RESERVECONTRACTDATE";
export const BILLING_SET_SETTLECONTRACTDATE = "BILLING_SET_SETTLECONTRACTDATE";
export const BILLING_MOVE_EVN_RESET_ERROR = "BILLING_MOVE_EVN_RESET_ERROR";
export const BILLING_RESET_GETBILLERROR = "BILLING_RESET_GETBILLERROR";

const successPayload = (action, state, res) => {
  return getJSON(res).then(json => json);
};

export const setReserveContractDate = date => ({
  type: BILLING_SET_RESERVECONTRACTDATE,
  date,
});

export const setSettleContractDate = date => ({
  type: BILLING_SET_SETTLECONTRACTDATE,
  date,
});

export const setErrorMessage = errorMessage => ({
  type: BILLING_SET_ERROR_MESSAGE,
  errorMessage,
});

const mapQueryParams = array => {
  const res = array.map(arr => (arr.value !== "" && arr.value !== null ? `&${arr.key}=` + arr.value : ""));
  return res.join("");
};

export const setFilter = filter => ({
  type: BILLING_SET_FILTER,
  filter,
});

export const clearFilter = () => ({
  type: BILLING_CLEAR_FILTER,
});

export const setDocumentFilter = filter => ({
  type: BILLING_DOCUMENT_SET_FILTER,
  filter,
});

export const setNavCompany = company => ({
  type: BILLING_DOCUMENT_SET_NAV_COMPANY,
  company,
});

export const clearDocumentFilter = () => ({
  type: BILLING_DOCUMENT_CLEAR_FILTER,
});

const queryParams = filter => [
  { key: "size", value: filter.amountOfLedgers },
  { key: "conferenceid", value: filter.confId },
  { key: "status", value: filter.status },
  { key: "confstarttime", value: filter.confStart },
  { key: "confendtime", value: filter.confEnd },
  { key: "error", value: filter.error },
  { key: "contract", value: filter.contract },
  { key: "productno", value: filter.productno },
  { key: "orderby", value: filter.orderBy },
  { key: "orderdirection", value: filter.orderDirection },
  { key: "name", value: filter.name },
  { key: "requestFrom", value: filter.requestFrom },
  { key: "participantName", value: filter.participantName },
  { key: "b_PhoneNumber", value: filter.bPhoneNumber },
  { key: "billing_point", value: filter.billingPoint },
  { key: "billing_time", value: filter.billingTime },
];

const queryParamsDocumentSending = filter => [
  { key: "fromEntryNo", value: filter.fromEntryNo },
  { key: "toEntryNo", value: filter.toEntryNo },
  {
    key: "fromPostingDate",
    value: filter.fromPostingDate,
  },
  {
    key: "toPostingDate",
    value: filter.toPostingDate,
  },
  { key: "dispatchComment", value: filter.dispatchComment },
  { key: "navCompany", value: filter.navCompany },
];

export const requestLedgerEntry = ledgerEntryId => {
  return {
    [RSAA]: {
      endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/billingledgerentries/${ledgerEntryId}`,
      method: "GET",
      types: [
        BILLING_GET_LEDGER_ENTRY_REQUEST,
        {
          type: BILLING_GET_LEDGER_ENTRY_SUCCESS,
          payload: successPayload,
        },
        BILLING_GET_LEDGER_ENTRY_FAILURE,
      ],
    },
  };
};

export const requestLedgerEntries = filter => ({
  [RSAA]: {
    endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/billingledgerentries?start=${filter.page *
      filter.amountOfLedgers}${mapQueryParams(queryParams(filter))}`,
    method: "GET",
    types: [
      BILLING_GET_LEDGER_ENTRIES_REQUEST,
      {
        type: BILLING_GET_LEDGER_ENTRIES_SUCCESS,
        payload: successPayload,
      },
      BILLING_GET_LEDGER_ENTRIES_FAILURE,
    ],
  },
});

export const updateLedgerEntry = (id, ledgerEntry) => ({
  [RSAA]: {
    endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/billingledgerentries/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(ledgerEntry),
    types: [
      BILLING_PATCH_LEDGER_ENTRIES_REQUEST,
      {
        type: BILLING_PATCH_LEDGER_ENTRIES_SUCCESS,
        payload: successPayload,
      },
      BILLING_PATCH_LEDGER_ENTRIES_FAILURE,
    ],
  },
});

export const deleteLedgerEntry = id => ({
  [RSAA]: {
    endpoint: `${PASSCODE_SERVER}/pcm-backend/v1/billingledgerentries/${id}`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    types: [
      BILLING_DELETE_LEDGER_ENTRIES_REQUEST,
      BILLING_DELETE_LEDGER_ENTRIES_SUCCESS,
      BILLING_DELETE_LEDGER_ENTRIES_FAILURE,
    ],
  },
});

export const createBill = (contractNo, postingDate) => ({
  [RSAA]: {
    endpoint: `${BILLING_SERVER}/billing-service/v1/eventbilling/${contractNo}?postingDate=${postingDate}`,
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    types: [EVENT_BILLING_REQUEST, { type: EVENT_BILLING_SUCCESS, payload: successPayload }, EVENT_BILLING_FAILURE],
  },
});

export const resetBillingError = () => ({
  type: EVENT_BILLING_RESET_BILLERROR,
});

export const requestDocumentNumbers = (company, filter) => ({
  [RSAA]: {
    endpoint: `${BILLING_SERVER}/billing-service/v1/senddocumententries/company/${company}/filter?paperOnly=${
      filter.paperOnly
    }${mapQueryParams(queryParamsDocumentSending(filter))}`,
    method: "GET",
    headers: { "Content-Type": "application/json" },
    types: [
      BILLING_GET_DOCUMENT_NUMBERS_REQUEST,
      {
        type: BILLING_GET_DOCUMENT_NUMBERS_SUCCESS,
        payload: successPayload,
      },
      BILLING_GET_DOCUMENT_NUMBERS_FAILURE,
    ],
  },
});

export const sendingDocumentNumbers = (company, id, sendToTestAddress) => ({
  [RSAA]: {
    endpoint: `${BILLING_SERVER}/billing-service/v1/senddocumententries/company/${company}/${id}
    ${sendToTestAddress ? `?sendToTestAddress=true&testAddress=${sendToTestAddress}` : ""}`,
    method: "OPTIONS",
    headers: { "Content-Type": "application/json" },
    types: [
      BILLING_SEND_DOCUMENT_NUMBER_REQUEST,
      {
        type: BILLING_SEND_DOCUMENT_NUMBER_SUCCESS,
        payload: successPayload,
      },
      {
        type: BILLING_SEND_DOCUMENT_NUMBER_FAILURE,
        meta: () => id,
      },
    ],
  },
});

export const reCheckErrors = () => ({
  [RSAA]: {
    endpoint: `${BILLING_SERVER}/billing-service/v1/blecheck/recheckallerrors`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    types: [
      BILLING_CHECK_ERRORS_REQUEST,
      {
        type: BILLING_CHECK_ERRORS_SUCCESS,
        payload: successPayload,
      },
      BILLING_CHECK_ERRORS_FAILURE,
    ],
  },
});

export const sendingDocumentNumberOnhold = (company, id) => ({
  [RSAA]: {
    endpoint: `${BILLING_SERVER}/billing-service/v1/senddocumententries/company/${company}/onhold/${id}`,
    method: "OPTIONS",
    headers: { "Content-Type": "application/json" },
    types: [
      BILLING_SEND_DOCUMENT_NUMBER_REQUEST,
      BILLING_SEND_DOCUMENT_NUMBER_SUCCESS,
      { type: BILLING_SEND_DOCUMENT_NUMBER_FAILURE, meta: () => id },
    ],
  },
});

export const resetContract = (contractNo, postingDate) => ({
  [RSAA]: {
    endpoint: `${BILLING_SERVER}/billing-service/v1/resetcontract/${contractNo}?postingDate=${postingDate}`,
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    types: [BILLING_RESET_CONTRACT_REQUEST, BILLING_RESET_CONTRACT_SUCCESS, BILLING_RESET_CONTRACT_FAILURE],
  },
});

export const moveEVN = (fromDocumentNo, toDocumentNo) => ({
  [RSAA]: {
    endpoint: `${BILLING_SERVER}/billing-service/v1/moveevn?fromDocumentNo=${fromDocumentNo}&toDocumentNo=${toDocumentNo}`,
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    types: [BILLING_MOVE_EVN_REQUEST, BILLING_MOVE_EVN_SUCCESS, BILLING_MOVE_EVN_FAILURE],
  },
});

export const restEVNError = () => ({
  type: BILLING_MOVE_EVN_RESET_ERROR,
});

export const resetFailures = () => ({
  type: EVENT_BILLING_RESET_BILLERROR,
});

export const resetGetBillError = () => ({
  type: BILLING_RESET_GETBILLERROR,
});
